'use client';

import Box from '@enlighten/design-system/dist/Box';
import { useTheme } from '@enlighten/design-system/dist/styles';
import Typography from '@enlighten/design-system/dist/Typography';
import useMediaQuery from '@enlighten/design-system/dist/useMediaQuery';
import { Apartment, Article, FactCheck, GridOn, House, LanguageOutlined, PaymentOutlined, PeopleAlt, TrendingDown } from '@mui/icons-material';
import { motion } from 'motion/react';
import React from 'react';

const OPTIONS = [
	{
		Icon: Apartment,
		title: '건물지원사업',
	},
	{
		Icon: LanguageOutlined,
		title: '탄소중립설비지원사업',
	},
	{
		Icon: PaymentOutlined,
		title: '금융지원사업',
	},
	{
		Icon: FactCheck,
		title: '팩토링',
	},
	{
		Icon: PeopleAlt,
		title: 'PPA 장기고정가격계약',
	},
	{
		Icon: Article,
		title: 'REC 판매',
	},
	{
		Icon: GridOn,
		title: '발전소 매각',
	},
	{
		Icon: House,
		title: '지붕임대사업',
	},
	{
		Icon: TrendingDown,
		title: '자가소비형 RE100 태양광 구독',
	},
];

const Section1SecondCard = () => {
	const theme = useTheme();
	const isTabletOrSmaller = useMediaQuery(theme.breakpoints.down('md'));

	const Comp = isTabletOrSmaller ? 'ul' : motion.ul;
	const options = React.useMemo(() => {
		return isTabletOrSmaller ? OPTIONS : [...OPTIONS, ...OPTIONS];
	}, [isTabletOrSmaller]);

	return (
		<Box
			maxWidth="566px"
			width="100%"
			height={{ xs: 'auto', md: '320px' }}
			overflow="hidden"
			sx={{
				'& ul': {
					display: 'flex',
					flexDirection: 'column',
					gap: '12px',
					padding: 0,
					margin: 0,
					listStyle: 'none',
				},
			}}
		>
			<Comp
				animate={{ y: ['0%', '-50%'] }}
				transition={{
					duration: 8,
					repeat: Infinity,
					ease: 'linear',
				}}
			>
				{options.map((option, index) => (
					<Box key={index} component="li" display="flex" justifyContent="center" alignItems="center" gap="8px" width="100%" height={{ xs: '40px', md: '60px' }} bgcolor="#F9F6FF" borderRadius="20px">
						<option.Icon color="primary" sx={{ fontSize: { xs: '20px', md: '24px' } }} />
						<Typography fontSize={{ xs: '14px', md: '18px' }} color="grey.A200">
							{option.title}
						</Typography>
					</Box>
				))}
			</Comp>
		</Box>
	);
};

export default Section1SecondCard;
